module.exports = __webpack_public_path__ + "assets/feature6-8902bafe6dac4af85754b85f9b758c06.svg";